import { render, staticRenderFns } from "./SupportUserTicketDetail.vue?vue&type=template&id=1efe50df&scoped=true&"
import script from "./SupportUserTicketDetail.vue?vue&type=script&lang=js&"
export * from "./SupportUserTicketDetail.vue?vue&type=script&lang=js&"
import style0 from "./SupportUserTicketDetail.vue?vue&type=style&index=0&id=1efe50df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efe50df",
  null
  
)

export default component.exports